import { useState, useEffect } from 'react';
import { Table, Tag, Button, Modal, Input, message, Space } from 'antd';
import { CheckOutlined, CloseOutlined, FileTextOutlined } from '@ant-design/icons';

const InvoiceManage = () => {
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [rejectModal, setRejectModal] = useState(null);
  const [rejectReason, setRejectReason] = useState('');
  const [detailInvoice, setDetailInvoice] = useState(null);
  const [detailItems, setDetailItems] = useState([]);
  const [detailLoading, setDetailLoading] = useState(false);

  useEffect(() => { fetchInvoices(); }, []);

  const token = () => localStorage.getItem('admin_token') || '';

  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/invoices', { headers: { Authorization: 'Bearer ' + token() } }).then(r => r.json());
      if (res.code === 0) setInvoices(res.data?.list || []);
    } catch(e) {
      console.error('获取发票列表失败', e);
    }
    setLoading(false);
  };

  const showDetail = async (inv) => {
    setDetailInvoice(inv);
    setDetailItems([]);
    setDetailLoading(true);
    try {
      const res = await fetch(`/api/admin/invoices/${inv.id}/items`, { headers: { Authorization: 'Bearer ' + token() } }).then(r => r.json());
      if (res.code === 0) setDetailItems(res.data?.items || []);
    } catch(e) {}
    setDetailLoading(false);
  };

  const handleReview = async (id, status) => {
    try {
      const res = await fetch(`/api/admin/invoices/${id}/review`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token() },
        body: JSON.stringify({ status, reject_reason: status === 'rejected' ? rejectReason : '' }),
      }).then(r => r.json());
      if (res.code === 0) {
        message.success(status === 'approved' ? '已通过' : '已拒绝');
        setRejectModal(null);
        setRejectReason('');
        fetchInvoices();
      }
    } catch(e) { message.error('操作失败'); }
  };

  const statusTag = (s) => {
    const m = { pending: {color:'orange',text:'待审核'}, approved: {color:'green',text:'已通过'}, rejected: {color:'red',text:'已拒绝'} };
    const c = m[s] || {color:'default',text:s};
    return <Tag color={c.color}>{c.text}</Tag>;
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '用户ID', dataIndex: 'user_id', width: 80 },
    { title: '发票号', dataIndex: 'invoice_no', render: v => v || '-', width: 200 },
    { title: '抬头', dataIndex: 'title', width: 200, ellipsis: true },
    { title: '税号', dataIndex: 'tax_no', render: v => v || '-', width: 220 },
    { title: '金额', dataIndex: 'amount', render: v => `¥${(v||0).toFixed(2)}`, width: 100 },
    { title: '类型', dataIndex: 'type', render: v => v==='vat'?'专票':'普票', width: 70 },
    { title: '状态', dataIndex: 'status', render: s => statusTag(s), width: 90 },
    { title: '备注', dataIndex: 'notes', render: v => v || '-', width: 110, ellipsis: true },
    { title: '拒绝原因', dataIndex: 'reject_reason', render: v => v || '-', ellipsis: true },
    { title: '时间', dataIndex: 'created_at', render: v => v?.substring(0,16), width: 160 },
    { title: '明细', width: 70, render: (_, r) => <Button type="link" size="small" onClick={() => showDetail(r)}>查看</Button> },
    { title: '操作', width: 140, render: (_, r) => r.status === 'pending' ? (
      <Space>
        <Button type="link" icon={<CheckOutlined />} onClick={() => handleReview(r.id, 'approved')}>通过</Button>
        <Button type="link" danger icon={<CloseOutlined />} onClick={() => setRejectModal(r.id)}>拒绝</Button>
      </Space>
    ) : null },
  ];

  const detailColumns = [
    { title: '类型', dataIndex: 'item_type', render: v => v==='bill'?'消费':'充值', width: 70 },
    { title: '模型/订单号', dataIndex: 'ref_no', ellipsis: true },
    { title: '时间', dataIndex: 'date', width: 160 },
    { title: '金额', dataIndex: 'amount', render: v => `¥${(v||0).toFixed(6)}`, width: 100 },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2><FileTextOutlined /> 发票审核</h2>
      <Table dataSource={invoices} columns={columns} rowKey="id" loading={loading} scroll={{ x: 'max-content' }} pagination={{ pageSize: 20 }} />
      <Modal title="拒绝原因" open={!!rejectModal} onOk={() => handleReview(rejectModal, 'rejected')} onCancel={() => setRejectModal(null)}>
        <Input.TextArea rows={3} value={rejectReason} onChange={e => setRejectReason(e.target.value)} placeholder="请输入拒绝原因" />
      </Modal>
      <Modal title={`发票明细 - #${detailInvoice?.id || ''}`} open={!!detailInvoice} onCancel={() => setDetailInvoice(null)} footer={null} width={550}>
        {detailInvoice && (
          <div>
            <p>抬头: {detailInvoice.title} | 金额: ¥{detailInvoice.amount?.toFixed(2)} | {statusTag(detailInvoice.status)}</p>
            <Table dataSource={detailItems} columns={detailColumns} rowKey="item_id" size="small" loading={detailLoading} pagination={{ pageSize: 15 }}
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={3} align="right"><strong>共 {detailItems.length} 条</strong></Table.Summary.Cell>
                  <Table.Summary.Cell index={3}><strong>¥{detailInvoice.amount?.toFixed(2)}</strong></Table.Summary.Cell>
                </Table.Summary.Row>
              )}
            />
          </div>
        )}
      </Modal>
    </div>
  );
};

export default InvoiceManage;
